/* eslint-disable */
Object.defineProperty(exports, '__esModule', {
  value: true
});
const dom_1 = require('./utils/dom');
const $ = require('cash-dom');
let Direction;
(function (Direction) {
  Direction[Direction.Backward = -1] = 'Backward';
  Direction[Direction.Forward = 1] = 'Forward';
})(Direction || (Direction = {}));
let MenuPosition;
(function (MenuPosition) {
  MenuPosition.Left = 'left';
  MenuPosition.Right = 'right';
})(MenuPosition || (MenuPosition = {}));
let Action;
(function (Action) {
  Action.Back = 'back';
  Action.Close = 'close';
  Action.Forward = 'forward';
  Action.Navigate = 'navigate';
  Action.Open = 'open';
})(Action || (Action = {}));
const DEFAULT_OPTIONS = {
  backLinkAfter: '',
  backLinkBefore: '<span class="prew-default-double-arrows"></span>',
  keyClose: '',
  keyOpen: '',
  position: 'right',
  showBackLink: true,
  showTitle: true,
  parentTitle: false,
  backLinkTitle: 'parent',
  submenuLinkAfter: '<span class="next-default-arrow"></span>',
  submenuLinkBefore: '',
  subMenuLinkEnable: false,
  slideContent: '',
  saveMenuState: true,
  subMegaMenuLevel: null,
  onOpen: null,
  onClose: null
};
const SlideMenu = function () {
  function SlideMenu(elem, options) {
    this.level = 0;
    this.isOpen = false;
    this.isAnimating = false;
    this.lastAction = null;
    if (elem === null) {
      throw new Error('Argument `elem` must be a valid HTML node');
    }
    // (Create a new object for every instance)
    this.options = {
      ...DEFAULT_OPTIONS,
      ...options
    };
    this.menuElem = elem;
    // Add wrapper (for the slide effect)
    this.wrapperElem = document.createElement('div');
    this.wrapperElem.classList.add(SlideMenu.CLASS_NAMES.wrapper);
    const firstUl = this.menuElem.querySelector(`.${SlideMenu.CLASS_NAMES.list}`);
    if (firstUl) {
      dom_1.wrapElement(firstUl, this.wrapperElem);
    }
    this.initMenu();
    this.initSubmenus();
    this.initEventHandlers();
    // Save this instance in menu DOM node
    this.menuElem._slideMenu = this;
    this.isMegaLevel = false;
  }
  /**
   * Toggle the menu
   */
  SlideMenu.prototype.toggle = function (show, animate) {
    if (animate === void 0) {
      animate = true;
    }
    let offset;
    const leftPosition = this.options.position === MenuPosition.Left;
    const slideContentClass = leftPosition ? SlideMenu.CLASS_NAMES.slideContentLeft : SlideMenu.CLASS_NAMES.slideContentRight;
    const translateContentValue = leftPosition ? `${this.menuElem.offsetWidth}px` : `${-this.menuElem.offsetWidth}px`;
    if (show === undefined) {
      return this.isOpen ? this.close(animate) : this.open(animate);
    }
    if (show) {
      offset = 0;
      if (this.options.slideContent) {
        document.getElementsByClassName(this.options.slideContent)[0].classList.add(slideContentClass);
        document.getElementsByClassName(this.options.slideContent)[0].style.transform = `translateX(${translateContentValue})`;
      }
    } else {
      offset = this.options.position === MenuPosition.Left ? '-100%' : '100%';
      if (this.options.slideContent) {
        document.getElementsByClassName(this.options.slideContent)[0].classList.remove(slideContentClass);
        document.getElementsByClassName(this.options.slideContent)[0].style.transform = 'translateX(0)';
      }
    }
    this.isOpen = show;
    if (animate) {
      this.moveSlider(this.menuElem, offset);
    } else {
      const action = this.moveSlider.bind(this, this.menuElem, offset);
      this.runWithoutAnimation(action);
    }
  };
  /**
   * Open the menu
   */
  SlideMenu.prototype.open = function (animate) {
    if (animate === void 0) {
      animate = true;
    }
    this.triggerEvent(Action.Open);
    this.toggle(true, animate);
    this.menuElem.setAttribute('tabindex', 0);
    this.menuElem.focus();
    document.getElementsByTagName('html')[0].classList.add('slide-menu-opened');
    if (typeof this.options.onOpen === 'function') this.options.onOpen();
  };
  /**
   * Close the menu
   */
  SlideMenu.prototype.close = function (animate) {
    if (animate === void 0) {
      animate = true;
    }
    this.triggerEvent(Action.Close);
    this.toggle(false, animate);
    this.hideChildMega();
    this.menuElem.removeAttribute('tabindex');
    if (this.options.saveMenuState === false) {
      this.navigateTo(`.${SlideMenu.CLASS_NAMES.listItem}`);
    }
    document.getElementsByTagName('html')[0].classList.remove('slide-menu-opened');
    if (typeof this.options.onClose === 'function') this.options.onClose();
  };
  /**
   * Navigate one menu hierarchy back if possible
   */
  SlideMenu.prototype.back = function () {
    // Event is triggered in navigate()
    this.navigate(Direction.Backward);
  };
  /**
   * Destroy the SlideMenu
   */
  SlideMenu.prototype.destroy = function () {
    const _a = this.options;
    const {
      submenuLinkAfter
    } = _a;
    const {
      submenuLinkBefore
    } = _a;
    const {
      showBackLink
    } = _a;
    // Remove link decorators
    if (submenuLinkAfter || submenuLinkBefore) {
      const linkDecorators = Array.from(this.wrapperElem.querySelectorAll(`.${SlideMenu.CLASS_NAMES.decorator}`));
      const titleLinks = Array.from(this.wrapperElem.querySelectorAll(`.${SlideMenu.CLASS_NAMES.title}`));
      titleLinks.forEach(titleLink => {
        if (titleLink.parentElement) {
          titleLink.parentElement.removeChild(titleLink);
        }
      });
      linkDecorators.forEach(decorator => {
        if (decorator.parentElement) {
          decorator.parentElement.removeChild(decorator);
        }
      });
    }
    // Remove back links
    if (showBackLink) {
      const backLinks = Array.from(this.wrapperElem.querySelectorAll(`.${SlideMenu.CLASS_NAMES.control}`));
      backLinks.forEach(backlink => {
        const parentLi = dom_1.parentsOne(backlink, 'li');
        if (parentLi && parentLi.parentElement) {
          parentLi.parentElement.removeChild(parentLi);
        }
      });
    }
    // Remove the wrapper element
    dom_1.unwrapElement(this.wrapperElem);
    // Remove inline styles
    this.menuElem.style.cssText = '';
    this.menuElem.querySelectorAll(`.${SlideMenu.CLASS_NAMES.list}`).forEach(ul => ul.style.cssText = '');
    // Delete the reference to *this* instance
    // NOTE: Garbage collection is not possible, as long as other references to this object exist
    delete this.menuElem._slideMenu;
  };
  /**
   * Navigate to a specific link on any level (useful to open the correct hierarchy directly)
   */
  SlideMenu.prototype.navigateTo = function (target) {
    this.triggerEvent(Action.Navigate);
    if (typeof target === 'string') {
      const elem = document.querySelector(target);
      if (elem instanceof HTMLElement) {
        target = elem;
      } else {
        throw new Error('Invalid parameter `target`. A valid query selector is required.');
      }
    }
    // Hide other active menus
    const activeMenus = Array.from(this.wrapperElem.querySelectorAll(`.${SlideMenu.CLASS_NAMES.active}`));
    activeMenus.forEach(activeElem => {
      activeElem.style.display = 'none';
      activeElem.classList.remove(SlideMenu.CLASS_NAMES.active);
    });
    const parentUl = dom_1.parents(target, `.${SlideMenu.CLASS_NAMES.list}`);
    const $parent = $(target).parents(`.${SlideMenu.CLASS_NAMES.list}`);
    $parent.children(`.${SlideMenu.CLASS_NAMES.listItem}`).children(`.${SlideMenu.CLASS_NAMES.link}`).attr('tabindex', '-1');
    const level = parentUl.length - 1;
    // Trigger the animation only if currently on different level
    if (level >= 0 && level !== this.level) {
      this.level = level;
      this.moveSlider(this.wrapperElem, -this.level * 100);
    }
    parentUl.forEach(ul => {
      ul.style.display = 'flex';
      ul.classList.add(SlideMenu.CLASS_NAMES.active);
    });
  };
  /**
   * Set up all event handlers
   */
  SlideMenu.prototype.initEventHandlers = function () {
    const _this = this;
    // Ordinary links inside the menu
    const anchors = Array.from(this.menuElem.querySelectorAll('a:not(.__ignore)'));
    anchors.forEach(anchor => anchor.addEventListener('click', event => {
      const {
        target
      } = event;
      const targetAnchor = target.matches('a') ? target : dom_1.parentsOne(target, 'a');
      const {
        level,
        action
      } = anchor.dataset;
      const isMega = _this.options.subMegaMenuLevel && level && level >= _this.options.subMegaMenuLevel;
      if (targetAnchor) {
        if (!!isMega && !action) {
          _this.megaSlide(Direction.Forward, targetAnchor);
        } else if (level < this.level) {
          _this.navigateTo(target.nextElementSibling);
        } else {
          _this.navigate(Direction.Forward, targetAnchor);
        }
      }
    }));
    // Handler for end of CSS transition
    this.menuElem.addEventListener('transitionend', this.onTransitionEnd.bind(this));
    this.wrapperElem.addEventListener('transitionend', this.onTransitionEnd.bind(this));
    this.initKeybindings();
    this.initSubmenuVisibility();
  };
  SlideMenu.prototype.onTransitionEnd = function (event) {
    // Ensure the transitionEnd event was fired by the correct element
    // (elements inside the menu might use CSS transitions as well)
    if (event.target !== this.menuElem && event.target !== this.wrapperElem) {
      return;
    }
    this.isAnimating = false;
    if (this.lastAction) {
      this.triggerEvent(this.lastAction, true);
      this.lastAction = null;
    }
  };
  SlideMenu.prototype.initKeybindings = function () {
    const _this = this;
    document.addEventListener('keydown', event => {
      switch (event.key) {
        case _this.options.keyClose:
          _this.close();
          break;
        case _this.options.keyOpen:
          _this.open();
          break;
        default:
          return;
      }
      event.preventDefault();
    });
  };
  SlideMenu.prototype.initSubmenuVisibility = function () {
    const _this = this;
    // Hide the lastly shown menu when navigating back (important for navigateTo)
    this.menuElem.addEventListener('sm.back-after', () => {
      const lastActiveSelector = `.${SlideMenu.CLASS_NAMES.active} `.repeat(_this.level + 1);
      const lastActiveUl = _this.menuElem.querySelector(`.${SlideMenu.CLASS_NAMES.list} ${lastActiveSelector}`);
      if (lastActiveUl) {
        lastActiveUl.style.display = 'none';
        lastActiveUl.classList.remove(SlideMenu.CLASS_NAMES.active);
      } else {
        lastActiveSelector.classList.remove(SlideMenu.CLASS_NAMES.linkActive);
      }
    });
  };
  /**
   * Trigger a custom event to support callbacks
   */
  SlideMenu.prototype.triggerEvent = function (action, afterAnimation) {
    if (afterAnimation === void 0) {
      afterAnimation = false;
    }
    this.lastAction = action;
    const name = `sm.${action}${afterAnimation ? '-after' : ''}`;
    const event = new CustomEvent(name);
    this.menuElem.dispatchEvent(event);
  };
  /**
   * Navigate the menu - that is slide it one step left or right
   */
  SlideMenu.prototype.navigate = function (dir, anchor) {
    if (dir === void 0) {
      dir = Direction.Forward;
    }
    if (this.isAnimating || dir === Direction.Backward && this.level === 0) {
      return;
    }
    if (dir !== Direction.Forward) this.hideChildMega(false, true);
    const offset = (this.level + dir) * -100;
    if (anchor && anchor.parentElement !== null && dir === Direction.Forward) {
      const ul = anchor.parentElement.querySelector(`.${SlideMenu.CLASS_NAMES.list}`);
      const $disabledLinks = $(anchor.parentElement).siblings(`.${SlideMenu.CLASS_NAMES.listItem}`).children(`.${SlideMenu.CLASS_NAMES.link}`);
      $disabledLinks.add($(anchor.parentElement).children(`.${SlideMenu.CLASS_NAMES.link}`)).attr('tabindex', '-1');
      if (!ul) {
        return;
      }
      ul.classList.add(SlideMenu.CLASS_NAMES.active);
      ul.style.display = 'flex';
    }
    const action = dir === Direction.Forward ? Action.Forward : Action.Back;
    this.triggerEvent(action);
    this.level += dir;
    $(`.${SlideMenu.CLASS_NAMES.link}[data-level="${this.level}"]`).attr('tabindex', 0);
    this.moveSlider(this.wrapperElem, offset);
  };
  /**
   * Mega menu item - toggle submenu from the side
   */
  SlideMenu.prototype.megaSlide = function (dir, anchor) {
    anchor.classList.add(SlideMenu.CLASS_NAMES.linkActive);
    const $subMenu = $(anchor).next(`.${SlideMenu.CLASS_NAMES.list}`);
    const {
      level
    } = anchor.dataset;
    if (!$subMenu.length) return;
    this.hideChildMega(anchor);
    $subMenu.css('display', 'flex');
    $subMenu.addClass(SlideMenu.CLASS_NAMES.active);
    this.level = parseInt(level, 10);
    this.menuElem.classList.add('slide-menu--mega');
    this.triggerEvent(Action.Navigate, true);
  };
  SlideMenu.prototype.hideChildMega = function (anchor, resetLevel = false) {
    if (!this.menuElem.classList.contains('slide-menu--mega')) return;
    let $siblingAnchors = $(anchor).parent('li').siblings('li').find('a');
    if (resetLevel) this.level = 1;

    // Select all mega menus
    if (!anchor) {
      $siblingAnchors = $(this.menuElem).find(`a[data-level="0"]`);
      $siblingAnchors.add($siblingAnchors.find('a'));
    } else {
      const {
        level
      } = anchor.dataset;
      this.level = parseInt(level, 10);
    }
    this.menuElem.classList.remove('slide-menu--mega');
    $siblingAnchors.each((index, link) => {
      const $link = $(link);
      const $childUl = $link.next(`.${SlideMenu.CLASS_NAMES.list}`);
      $link.removeClass(SlideMenu.CLASS_NAMES.linkActive);
      if (!$childUl.length) return;
      $childUl.css('display', 'none');
      $childUl.removeClass(SlideMenu.CLASS_NAMES.active);
    });
  };
  /**
   * Start the slide animation (the CSS transition)
   */
  SlideMenu.prototype.moveSlider = function (elem, offset) {
    // Add percentage sign
    if (!offset.toString().includes('%')) {
      offset += '%';
    }
    elem.style.transform = `translateX(${offset})`;
    this.isAnimating = true;
  };
  /**
   * Initialize the menu
   */
  SlideMenu.prototype.initMenu = function () {
    const _this = this;
    this.runWithoutAnimation(() => {
      switch (_this.options.position) {
        case MenuPosition.Left:
          Object.assign(_this.menuElem.style, {
            left: 0,
            right: 'auto',
            transform: 'translateX(-100%)'
          });
          break;
        default:
          Object.assign(_this.menuElem.style, {
            left: 'auto',
            right: 0
          });
          break;
      }
      _this.menuElem.style.display = 'flex';
    });
  };
  /**
   * Pause the CSS transitions, to apply CSS changes directly without an animation
   */
  SlideMenu.prototype.runWithoutAnimation = function (action) {
    const transitionElems = [this.menuElem, this.wrapperElem];
    transitionElems.forEach(elem => elem.style.transition = 'none');
    action();
    this.menuElem.offsetHeight; // Trigger a reflow, flushing the CSS changes
    transitionElems.forEach(elem => elem.style.removeProperty('transition'));
    this.isAnimating = false;
  };
  /**
   * Enhance the markup of menu items which contain a submenu
   */
  SlideMenu.prototype.initSubmenus = function () {
    const _this = this;
    this.menuElem.querySelectorAll('a').forEach(anchor => {
      if (anchor.parentElement === null) {
        return;
      }
      const submenu = anchor.parentElement.querySelector('ul');
      if (!submenu) {
        return;
      }
      let backLinkTitle = anchor.parentElement.parentElement.classList.contains("_level-1") ? 'Menu' : anchor.parentElement.parentElement.parentElement.querySelectorAll(`.${SlideMenu.CLASS_NAMES.link}`)[0].textContent;
      let titleLinkTitle = anchor.parentElement.querySelectorAll(`.${SlideMenu.CLASS_NAMES.link}`).length ? anchor.parentElement.querySelectorAll(`.${SlideMenu.CLASS_NAMES.link}`)[0].textContent : 'Menu';

      // Prevent default behaviour (use link just to navigate)
      anchor.addEventListener('click', event => {
        event.preventDefault();
      });
      const anchorText = anchor.textContent;
      if (_this.options.backLinkTitle === 'current') {
        backLinkTitle = anchorText;
      }
      _this.addLinkDecorators(anchor);
      // Add Title
      if (_this.options.showTitle) {
        const _t = _this.options;
        const title = document.createElement('a');
        title.innerHTML = titleLinkTitle;
        title.classList.add(SlideMenu.CLASS_NAMES.title);
        title.setAttribute('href', anchor.getAttribute('href'));
        const titleLi = document.createElement('li');
        titleLi.appendChild(title);
        titleLi.classList.add(SlideMenu.CLASS_NAMES.listItem);
        submenu.insertBefore(titleLi, submenu.firstChild);
      }
      // Add back links
      if (_this.options.showBackLink) {
        const _a = _this.options;
        const {
          backLinkBefore,
          backLinkAfter
        } = _a;
        const backLink = document.createElement('span');
        backLink.innerHTML = backLinkBefore + backLinkTitle + backLinkAfter;
        backLink.classList.add(SlideMenu.CLASS_NAMES.backlink, SlideMenu.CLASS_NAMES.control);
        backLink.setAttribute('data-action', Action.Back);
        backLink.setAttribute('tabindex', 0);
        backLink.addEventListener('keydown', e => {
          if (e.key !== 'Enter') return;
          this.back();
        });
        const backLinkLi = document.createElement('li');
        backLinkLi.appendChild(backLink);
        backLinkLi.classList.add(SlideMenu.CLASS_NAMES.listItem);
        submenu.insertBefore(backLinkLi, submenu.firstChild);
      }
    });
  };
  // Add `before` and `after` text
  SlideMenu.prototype.addLinkDecorators = function (anchor) {
    const _a = this.options;
    const {
      submenuLinkBefore
    } = _a;
    const {
      submenuLinkAfter
    } = _a;
    if (submenuLinkBefore) {
      const linkBeforeElem = document.createElement('span');
      linkBeforeElem.classList.add(SlideMenu.CLASS_NAMES.decorator);
      linkBeforeElem.innerHTML = submenuLinkBefore;
      anchor.insertBefore(linkBeforeElem, anchor.firstChild);
    }
    if (submenuLinkAfter) {
      const linkAfterElem = document.createElement('span');
      linkAfterElem.classList.add(SlideMenu.CLASS_NAMES.decorator);
      linkAfterElem.innerHTML = submenuLinkAfter;
      anchor.appendChild(linkAfterElem);
    }
    return anchor;
  };
  SlideMenu.NAMESPACE = 'slide-menu';
  SlideMenu.CLASS_NAMES = {
    active: `${SlideMenu.NAMESPACE}--submenu--active`,
    linkActive: `${SlideMenu.NAMESPACE}--link--active`,
    link: `${SlideMenu.NAMESPACE}--link`,
    backlink: `${SlideMenu.NAMESPACE}--backlink`,
    control: `${SlideMenu.NAMESPACE}--control`,
    decorator: `${SlideMenu.NAMESPACE}--decorator`,
    wrapper: `${SlideMenu.NAMESPACE}--slider`,
    title: `${SlideMenu.NAMESPACE}--title`,
    list: `${SlideMenu.NAMESPACE}--list`,
    listItem: `${SlideMenu.NAMESPACE}--list-item`,
    slideContentRight: `${SlideMenu.NAMESPACE}--right-menu-active`,
    slideContentLeft: `${SlideMenu.NAMESPACE}--left-menu-active`
  };
  return SlideMenu;
}();

// Link control buttons with the API
document.addEventListener('click', event => {
  if (!(event.target instanceof HTMLElement)) {
    return;
  }
  const btn = event.target.className.includes(SlideMenu.CLASS_NAMES.control) ? event.target : dom_1.parentsOne(event.target, `.${SlideMenu.CLASS_NAMES.control}`);
  if (!btn || !btn.className.includes(SlideMenu.CLASS_NAMES.control)) {
    return;
  }
  const target = btn.getAttribute('data-target');
  const menu = !target || target === 'this' ? dom_1.parentsOne(btn, `.${SlideMenu.NAMESPACE}`) : document.getElementById(target); // assumes #id
  if (!menu) {
    throw new Error(`Unable to find menu ${target}`);
  }
  const instance = menu._slideMenu;
  const method = btn.getAttribute('data-action');
  const arg = btn.getAttribute('data-arg');
  if (instance && method && typeof instance[method] === 'function') {
    arg ? instance[method](arg) : instance[method]();
  }
});

// Expose SlideMenu to the global namespace
window.SlideMenu = SlideMenu;
export default SlideMenu;